import { IAppState } from '../../redux';
import { selectIsShortForm } from '../layout';

export const selectAnalyticsFormType = (state: IAppState): string => {
  const isShortForm = selectIsShortForm(state);

  return isShortForm ? 'short' : 'full';
};
